/**
 * moment-swatches.js
 * Задаёт цвета кружков для вариантов-цветов кристаллов.
 */
(function () {
  var colorMap = {
    '1. lila':        '#c8a7e0',
    '2. rosado':      '#f4a7b9',
    '3. verde claro': '#a8d89c',
    '4. amarillo':    '#f5e06b',
    '5. azul':        '#5b9bd5',
    '6. violeta':     '#8b5db0',
    '7. verde':       '#3a9c5a',
    '8. celeste':     '#7ec8e3',
    '9. verde oliva': '#7a9648',
    '10. rojo':       '#c53030',
    '11. blanco':     '#ece8e0',
    'negro':          '#1a1a1a',
    'blanco':         '#f8f8f8',
    'rojo':           '#c0392b',
    'azul':           '#2980b9',
    'verde':          '#27ae60',
    'amarillo':       '#f1c40f',
    'rosado':         '#e91e8c',
    'rosa':           '#ff69b4',
    'naranja':        '#e67e22',
    'morado':         '#8e44ad',
    'violeta':        '#7b2d8b',
    'lila':           '#c8a7e0',
    'celeste':        '#87ceeb',
    'gris':           '#95a5a6',
    'dorado':         '#d4a017',
    'plateado':       '#b0b0b0',
    'transparente':   '#e8e8e8'
  };

  function applySwatchColors() {
    document.querySelectorAll('.swatch-input__input').forEach(function (input) {
      var raw = (input.value || '').trim();
      var key = raw.toLowerCase();
      var color = colorMap[key];
      if (!color) return;

      var label = input.parentElement
        ? input.parentElement.querySelector('label.swatch-input__label')
        : null;
      if (!label) {
        label = input.nextElementSibling;
      }
      if (label && label.classList.contains('swatch-input__label')) {
        label.style.setProperty('--swatch-color', color);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySwatchColors);
  } else {
    applySwatchColors();
  }

  document.addEventListener('variant:change', applySwatchColors);
  document.addEventListener('theme:variant:change', applySwatchColors);
})();
